import types from '../actionTypes';

export const imageMapsRequest = meta => ({
    type: types.IMAGE_MAPS_REQUEST,
    meta,
});

export const imageMapsRequestCompleted = () => ({
    type: types.IMAGE_MAPS_REQUEST_COMPLETED,
});
